export default "__VITE_ASSET__BAYa5qOe__"